import React, { ReactNode } from 'react'
import Skeleton from '@mui/material/Skeleton'
import Avatar from '@mui/material/Avatar'
import initials from 'initials'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

interface iAuthorAvatar {
  loading?: boolean
  fullName: string
  thumbnail?: string
  prefix?: ReactNode
  textColor?: string
  fontFamily?: string
}

const AuthorAvatar: React.FC<iAuthorAvatar> = ({ loading, fullName, thumbnail, prefix, textColor, fontFamily }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexFlow: 'row',
        alignItems: 'center',
        '& > *': {
          marginRight: 1
        }
      }}
    >
      {prefix ? (
        loading ? (
          <Skeleton animation="wave" variant="rectangular" width={24} height={24} />
        ) : (
          <div style={{ color: textColor ?? 'white', fontFamily: fontFamily }}>{prefix}</div>
        )
      ) : null}
      {loading ? (
        <Skeleton animation="wave" variant="circular" width={32} height={32} />
      ) : (
        <Avatar
          sx={{
            cursor: 'pointer',
            backgroundColor: 'transparent',
            border: '1px solid',
            borderColor: textColor && textColor?.length > 0 ? textColor : 'common.white',
            color: textColor && textColor?.length > 0 ? textColor : 'common.white',
            width: 32,
            height: 32,
            fontSize: '0.9em',
            '&>img': {
              objectFit: 'contain'
            },
            fontFamily: fontFamily
          }}
          src={thumbnail}
        >
          {initials(fullName)}
        </Avatar>
      )}
      {loading ? (
        <Skeleton animation="wave" variant="text" height={40} width="80%" />
      ) : (
        <Typography sx={{ color: textColor ?? '', fontFamily: fontFamily }}>{fullName}</Typography>
      )}
    </Box>
  )
}

export default React.memo(AuthorAvatar)
